import React from "react";
import "../styles/Home.css";
import food from "../assets/food2.jpg";
import cancelImg from "../assets/op.png";

export default function CancellationRefund() {
  return (
    <div>
      <section
        className="cancel-wrapper"
        style={{ marginLeft: "32px", marginRight: "32px" }}
      >
        <div className="cancel-container">
          <div className="cancel-left">
            <h2 style={{ fontSize: "2.5rem", color: "#39512f" }}>
              Cancellation and Refund
            </h2>
          </div>
        </div>
        <div className="cancel-container">
          <div className="cancel-left">
            {/* <h2>Cancellation and Refund</h2> */}
            <p className="cancel-date" style={{ fontSize: "16.73px" }}>
              Last updated on July 9 2025
            </p>
            <p style={{ fontSize: "15px" }}>
              ALFA SOUTHIN CAFE believes in helping its customers as far as
              possible, and has therefore a liberal cancellation policy. Under
              this policy:
            </p>
            <ul>
              <li style={{ fontSize: "15px" }} className="pb">
                Cancellations will be considered only if the request is made
                within same day of placing the order. However, the cancellation
                request may not be entertained if the orders have been
                communicated to the vendors/merchants and they have initiated
                the process of shipping them.
              </li>
              <li style={{ fontSize: "15px" }} className="pb">
                ALFA SOUTHIN CAFE does not accept cancellation requests for
                perishable items like flowers, eatables etc. However,
                refund/replacement can be made if the customer establishes that
                the quality of product delivered is not good.
              </li>
              <li style={{ fontSize: "15px" }} className="pb">
                In case of receipt of damaged or defective items please report
                the same to our Customer Service team. The request will,
                however, be entertained once the merchant has checked and
                determined the same at his own end. This should be reported
                within same day of receipt of the products.
              </li>
              <li style={{ fontSize: "15px" }} className="pb">
                In case you feel that the product received is not as shown on
                the site or as per your expectations, you must bring it to the
                notice of our customer service within same day of receiving the
                product. The Customer Service Team after looking into your
                complaint will take an appropriate decision.
              </li>
              <li style={{ fontSize: "15px" }}>
                In case of any Refunds approved by the ALFA SOUTHIN CAFE, it’ll
                take same day for the refund to be processed to the end
                customer.
              </li>
            </ul>
          </div>

          <div className="cancel-right">
            <h4 style={{ fontSize: "23.65px" }} className="intro-title12">
              Cancellation and Refund
            </h4>
            <img
              src={cancelImg}
              alt="Cancellation Refund"
              className="cancel-img "
            />
            <ul>
              <li style={{ fontSize: "15px", marginTop: "20px" }}>
                In case of complaints regarding products that come with a
                warranty from manufacturers, please refer the issue to them.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
